import { useDispatch } from 'react-redux'
import { PencilSquareIcon } from '@heroicons/react/24/outline'
import { openEditModal } from '../macroProcessEditSlice'
import { fetchTemplatesForEdit } from '../services/macroProcessEditService'

/**
 * @typedef {Object} MacroProcessEditButtonProps
 * @property {Object} macroProcess - Le macro process à éditer (doit être pending)
 */

/**
 * @param {MacroProcessEditButtonProps} props
 */
export default function MacroProcessEditButton({ macroProcess }) {
  const dispatch = useDispatch()

  const handleClick = () => {
    const macroProcessWithPendingContainers = {
      ...macroProcess,
      process_containers: (macroProcess.process_containers || []).filter(
        c => c.status === 'pending'
      ),
    }
    dispatch(openEditModal(macroProcessWithPendingContainers))
    dispatch(fetchTemplatesForEdit(macroProcess.purpose))
  }

  return (
    <button
      className="btn btn-sm btn-ghost btn-outline"
      onClick={handleClick}
      title="Ajouter des étapes"
      aria-label="Ajouter des étapes au macro process"
    >
      <PencilSquareIcon className="h-4 w-4" />
    </button>
  )
}
